<template>
  <div id="app">
    <Navbar v-if="user && $route.name !='avaliation' " />
    <router-view />
  </div>
</template>

<script>
import Navbar from '@/components/NavBar.vue';

export default {
  name: 'App',
  components: { Navbar },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style>
/* Estilos globais */
body {
  margin: 0;
  font-family: 'Arial', sans-serif;
  color: #333;
}
</style>
